export default __webpack_public_path__ + "static/media/img_ad_response-colorBkg.87d54518.png";